import { render, staticRenderFns } from "./room2.vue?vue&type=template&id=2db97415&"
import script from "./room2.vue?vue&type=script&lang=js&"
export * from "./room2.vue?vue&type=script&lang=js&"
import style0 from "./room2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports